var _Rect, _Rect2, _G, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
function SvgCircledArrowLeft(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    y: -0.004,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#1A1D43"
  })), _Rect2 || (_Rect2 = /*#__PURE__*/React.createElement(Rect, {
    x: 0.5,
    y: 0.496,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#fff",
    fill: "transparent"
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#circled-arrow-left_svg__clip0_13536_294)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M19 13.996a.31.31 0 00-.313-.306H9.312a.31.31 0 00-.312.306c0 .169.14.306.312.306h9.375a.31.31 0 00.313-.306z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M13.908 9.502a.318.318 0 00-.442 0L9.092 13.78a.3.3 0 000 .432l4.374 4.278c.123.12.32.12.442 0a.3.3 0 000-.432l-4.154-4.062 4.154-4.062a.3.3 0 000-.432z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "circled-arrow-left_svg__clip0_13536_294"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "translate(9 8.996)",
    d: "M0 0h10v10H0z"
  })))));
}
export default SvgCircledArrowLeft;